import {
    FETCH_CURRENT_YEAR_PAID_REQUEST,
    FETCH_CURRENT_YEAR_PAID_SUCCESS,
    FETCH_CURRENT_YEAR_PAID_FAILURE,
  } from "../actions/currentYearPaidActions";
  
  const initialState = {
    currentYearPaidList: [],
    loading: false,
    error: null,
  };
  
  const currentYearPaidReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_CURRENT_YEAR_PAID_REQUEST:
        return { ...state, loading: true, error: null };
  
      case FETCH_CURRENT_YEAR_PAID_SUCCESS:
        return { ...state, loading: false, currentYearPaidList: action.payload };
  
      case FETCH_CURRENT_YEAR_PAID_FAILURE:
        return { ...state, loading: false, error: action.payload };
  
      default:
        return state;
    }
  };
  
  export default currentYearPaidReducer;
  